import { render, staticRenderFns } from "./AppContent.vue?vue&type=template&id=8b526872&scoped=true&"
import script from "./AppContent.vue?vue&type=script&lang=ts&"
export * from "./AppContent.vue?vue&type=script&lang=ts&"
import style0 from "./AppContent.vue?vue&type=style&index=0&id=8b526872&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b526872",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b526872')) {
      api.createRecord('8b526872', component.options)
    } else {
      api.reload('8b526872', component.options)
    }
    module.hot.accept("./AppContent.vue?vue&type=template&id=8b526872&scoped=true&", function () {
      api.rerender('8b526872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppContainer/AppContent.vue"
export default component.exports